export function JudgeGuide({ step }: { step: 1 | 2 | 3 | 4 }) {
  const stateFor = (target: 1 | 2 | 3) => {
    if (step > target) return 'done'
    if (step === target) return 'active'
    return ''
  }

  return (
    <section className="demo-path" aria-label="Three-step Shotstead demo path">
      <div className={`demo-step ${stateFor(1)}`}>
        <span className="step-number">1</span>
        <span>
          <strong>Capture Take A</strong>
          <small>Shoot the committed Stage v1.</small>
        </span>
      </div>
      <div className={`demo-step ${stateFor(2)}`}>
        <span className="step-number">2</span>
        <span>
          <strong>Move only the camera</strong>
          <small>Commit the new angle as Stage v2.</small>
        </span>
      </div>
      <div className={`demo-step ${stateFor(3)}`}>
        <span className="step-number">3</span>
        <span>
          <strong>Capture Take B</strong>
          <small>Same world. New camera. Proven lineage.</small>
        </span>
      </div>
    </section>
  )
}
